<template>
  <div
    @click="toAiPage"
    :class="{
      'consult-default-adviser-point': true,
      'mask-show': isShowAd
    }"
  >
    <transition name="transition-fade">
      <div class="adviser-ad-container" v-if="isShowAd">
        <div class="adviser-ad">
          <icon name="m-close" class="close-btn" @click.native.stop="hide" />
          <div class="content">
            <!-- <p class="title">不知道如何挑选咨询师?</p> -->
            <p class="desc">不知道如何挑选咨询师？<br />先找我聊聊吧~</p>
          </div>
        </div>
      </div>
    </transition>
    <img
      v-if="option.hecong"
      class="hecong-img"
      :src="require('../../images/consult/serviceAssitance2.png') | imgZip(150)"
    />
    <img
      v-else
      :src="require('../../images/consult/serviceAssitance.png') | imgZip(150)"
    />
    <!-- <span class="adviser-after">专属顾问</span> -->
  </div>
</template>

<script>
// import serviceEntrance from './serviceEntrance'
const cachekey = `__serviceEntrance__show__cache_key__3`
const parseDate = (date = new Date()) => {
  return date.getFullYear() + '' + (date.getMonth() + 1) + '' + date.getDate()
}
export default {
  props: {
    showAd: {
      type: Boolean,
      default: false
    },
    trackName: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => {
        return {
          hecong: false
        }
      }
    }
  },
  components: {
    // serviceEntrance
  },
  data() {
    let showMask = false
    if (!this.$isServer) {
      try {
        const cache = window.localStorage.getItem(cachekey)
        if (!cache || parseDate() !== parseDate(new Date(+cache))) {
          showMask = true
        }
      } catch (e) {
        console.log(e)
      }
    }
    return {
      showMask
    }
  },
  methods: {
    hide() {
      window.localStorage.setItem(cachekey, +new Date())
      this.showMask = false
    },
    toAiPage() {
      if (this.option.hecong) return
      if (this.trackName) {
        this.$trackEvent(this.trackName, {
          page_title: this.$route.meta.pageName || '',
          touch_name: '悬浮框'
        })
      }
      this.eventStat('点击AI小助手')
      this.routerToStaic({
        path: '/consult-assistant'
      })
    }
  },
  computed: {
    isShowAd() {
      const { showMask, showAd } = this
      return showMask && showAd
    }
  }
}
</script>

<style lang="scss">
.consult-default-adviser-point {
  width: 96px;
  height: 96px;
  box-sizing: border-box;
  position: relative;
  &.mask-show {
    width: 439px + 48px;
  }

  img {
    border-radius: 50%;
    width: 96px;
    border: 4px solid #fff;
    box-shadow: 0 6px 20px 0 rgba(188, 194, 207, 0.29);
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    box-sizing: border-box;
  }
  .hecong-img {
    width: 116px;
    border: none;
    box-shadow: none;
    border-radius: 0;
  }
  .adviser-after {
    width: 92px;
    height: 30px;
    border-radius: 15.5px;
    background: #fff;
    font-size: 18px;
    color: #21252d;
    line-height: 18px;
    position: absolute;
    // bottom: -4px;
    top: 86%;
    right: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
  }

  .adviser-ad-container {
    width: 439px;
    height: 96px;
    overflow: hidden;
    position: absolute;
    right: 48px;
    top: 0;
  }
  .adviser-ad {
    width: 439px;
    height: 96px;
    position: absolute;
    right: 0;
    top: 0;
    background-image: linear-gradient(90deg, #3ab0ff 0%, #54c8ff 100%);
    box-shadow: 0 10px 30px 0 rgba(186, 193, 207, 0.38);
    border-radius: 100px 4px 4px 100px;
    border-radius: 100px 4px 4px 100px;
    position: absolute;
    color: #ffffff;
    display: flex;
    align-items: center;
    text-align: justify;

    .close-btn {
      width: 77px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0.3;
      color: #e9eef1;
      font-size: 36px;
    }

    .title {
      font-size: 28px;
      font-weight: bold;
      line-height: 48px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    }
    .desc {
      // font-size: 17px;
      // line-height: 32px;
      font-size: 26px;
      color: #ffffff;
      letter-spacing: 0.46px;
      line-height: 34px;
      padding-left: 5px;
    }
  }
}
</style>
